module.exports = __webpack_public_path__ + "static/media/mastercard.90f24fad.svg";